// extracted by mini-css-extract-plugin
export var contrastLow = "_2y-1";
export var externalLink = "_2y-2";
export var externalLinkIcon = "_2y-3";
export var link = "_2y-0";
export var linkLabel = "_2y-4";